import { SET_LIST_STUDENT } from './studentConst';

export function setListStudent(student) {
  return {
    type: SET_LIST_STUDENT,
    student
  };
}
